export type DonationRedirectStatus = 'success' | 'cancel';

export interface DonationRedirectParams {
  donationId: string;
  platform: string;
  status: DonationRedirectStatus;
}

const trimTrailingSlash = (url: string | undefined): string => url?.trim()?.replace(/\/+$/, '') ?? '';

const buildQueryString = (params: DonationRedirectParams): string => {
  const query = new URLSearchParams();
  if (params.donationId) query.set('donationId', params.donationId);
  if (params.platform) query.set('platform', params.platform);
  if (params.platform === 'vercel') query.set('status', params.status);
  return query.toString();
};

export function getDonationRedirectUrl(params: DonationRedirectParams): string {
  const { status } = params;
  const pathSuffix = status === 'success' ? 'donation-success' : 'donation-cancel';
  const queryStr = buildQueryString(params);
  const queryPart = queryStr ? `?${queryStr}` : '';

  const appUrl = trimTrailingSlash(process.env.REACT_APP_APP_URL);
  const vercelBaseUrl = trimTrailingSlash(process.env.REACT_APP_VERCEL_URL);
  const vercelDonationUrl = vercelBaseUrl ? `${vercelBaseUrl}/donation` : '';

  if (params.platform === 'vercel' && vercelDonationUrl) {
    return `${vercelDonationUrl}${queryPart}`;
  }
  if (appUrl) {
    return `${appUrl}/${pathSuffix}${queryPart}`;
  }
  return `${window.location.origin}/${pathSuffix}${queryPart}`;
}
